// extracted by mini-css-extract-plugin
export default {"myfirstcpnblog":"myfirstcpnblog_ec0a6f4641a2b31d45fa"};